export default __webpack_public_path__ + "static/media/waffle8.7c22a83f.png";